import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import styled from 'styled-components'
import Mixin from 'components/common/Mixin'
import NewValuePropositionWrapper from './components/NewValuePropositionWrapper'
import { generateTrustmaryWidgetScript } from 'helpers/generateTrustmaryWidget'

const nonce = window && window.BOT_NONCE

const MainHeadlineContent = ({
  placeholders: {
    heroContentBlock = []
  } = {}
}) =>
  <>
    {/* Trustmary reviews script */}
    <Helmet>
      <script nonce={ nonce } type="text/javascript">
        {generateTrustmaryWidgetScript()}
      </script>
    </Helmet>

    <Wrapper>
      <NewValuePropositionWrapper />
      { heroContentBlock.slice(0, 1) }
    </Wrapper>

    {/* Trustmary reviews widget container */}
    <div data-trustmary-widget="2o-fvcABM" />
  </>


MainHeadlineContent.propTypes = {
  placeholders: PropTypes.shape()
}

export default MainHeadlineContent

const Wrapper = styled.div`
  position: relative;

  @media (min-width: 1024px) and (max-width: 1570px) {
    margin: 0 -50px;
  }

  &::after {
    content: "";
    position: absolute;
    bottom: -54px;
    z-index: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 80px;
    background: #fcfcfc;
    /* stylelint-disable-next-line property-no-vendor-prefix */
    -webkit-transform: skewY(-1.5deg);
    transform: skewY(-1.5deg);
    ${Mixin.desktopOnly()}
  }
`
